import { render, staticRenderFns } from "./AcceptAgreements.vue?vue&type=template&id=1801bc2a&scoped=true&"
import script from "./AcceptAgreements.vue?vue&type=script&lang=ts&"
export * from "./AcceptAgreements.vue?vue&type=script&lang=ts&"
import style0 from "./AcceptAgreements.vue?vue&type=style&index=0&id=1801bc2a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1801bc2a",
  null
  
)

export default component.exports